import { useNavigate } from "react-router-dom";
import PrimaryTextBtn from "./PrimaryTextBtn";
import { useTranslation } from "react-i18next";

export default function BackBtn() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    
    return <PrimaryTextBtn fullWidth={false} onClick={() => navigate(-1)} className="hidden md:block">
        <svg xmlns="http://www.w3.org/2000/svg" className="inline-block mr-1" width="1.5em" height="1.5em" fill="currentColor" viewBox="0 0 24 24">
            <path d="M14 7l-5 5 5 5V7z" />
        </svg>
        {t("backBtn")}
    </PrimaryTextBtn>
}
